export default __webpack_public_path__ + "cebdd506df8295123155a3d5bb3db81b.wav";